var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-page-box"},[_c('a-card',{attrs:{"title":"素材空间","bordered":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }